<template>
  <div>
    <div class="noBox">业务待开发,示例如下</div>
    <div class="noBody">
      <van-cell-group title="地标素材详情">
        <van-cell title="图片" :border="false">
          <img src="../assets/2222.jpg" alt="" style="width: 100%" />
        </van-cell>
        <van-cell title="地标编码" :border="false"
          >1asda1124124124fafasfasf3443</van-cell
        >
        <van-cell title="上传时间" :border="false">2022-10-11</van-cell>
        <van-cell title="使用权价格" :border="false" @click="getPrice"
          >使用权价格图</van-cell
        >
        <van-cell title="所有权价格" :border="false" @click="getPrice"
          >所有权价格图</van-cell
        >
      </van-cell-group>
    </div>
    <van-dialog v-model="show" title="使用权价格图" show-cancel-button>
      <div id="chartLineBox" style="width: 100%;height:300px"></div>
    </van-dialog>
    <van-dialog v-model="show1" title="所有权价格" show-cancel-button>
      <div id="chartLineBox1" style="width: 100%;height:300px"></div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      show1: false,
      chartLine: null,
    };
  },
  mounted() {},
  methods: {
    showCharts() {
      this.chartLine = this.echarts.init(
        document.getElementById("chartLineBox")
      );
      let option = {
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [1500, 2300, 2240, 2180, 1350, 1470, 2600],
            type: "line",
          },
        ],
      };
      // 指定图表的配置项和数据

      // 使用刚指定的配置项和数据显示图表。
      this.chartLine.setOption(option);
    },
    showCharts1() {
      this.chartLine = this.echarts.init(
        document.getElementById("chartLineBox1")
      );
      let option = {
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260],
            type: "line",
          },
        ],
      };
      // 指定图表的配置项和数据

      // 使用刚指定的配置项和数据显示图表。
      this.chartLine.setOption(option);
    },
    getPrice(val) {
      switch (val.target.innerHTML) {
        case "使用权价格图":
          this.show = true;
          setTimeout(()=>{
            this.showCharts();
          },1000)
          break;
        case "所有权价格图":
          this.show1 = true;
            setTimeout(()=>{
            this.showCharts1();
          },1000)
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.noBody {
  margin: 10px 12px;
}
.noBox {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  margin: 10px 12px;
}
</style>